import { createGtm } from "@gtm-support/vue-gtm";
import router from "@/router.js";

// const gtm_key = process.env.MIX_GTM_KEY;
const gtm_key = window.location.href.includes("https://e-chat") && "N2R55RR";
// console.log(6, process.env.MIX_GTM_KEY);
export default createGtm({
    id: "GTM-" + (gtm_key || "N2R55RR"),
    // queryParams: {
    //     gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
    //     gtm_preview: "env-4",
    //     gtm_cookies_win: "x",
    // },
    // source: "https://customurl.com/gtm.js", // Add your own serverside GTM script
    // nonce: "2726c7f26c",
    debug: !window.location.href.includes("https://e-chat"),
    vueRouter: router,
    ignoredViews: [],
});
